import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Content, Main } from "../../../components/Layout";
import style from "../style.module.css";
import api from "../../../services/api";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import Button from "../../../components/Button";
import ButtonLink from "../../../components/Button/ButtonLink";

export default function Aceite() {
  const { me, config } = useWrapper();
  const [isLoadingEssential, setisLoadingEssential] = useState(true);
  const [isLoadingSave, setisLoadingSave] = useState(false);
  const [contractUrl, setcontractUrl] = useState();
  useEffect(() => {
    me &&
      (async () => {
        try {
          setisLoadingEssential(true);
          let { data: _contract_id } = await api.get(
            `trainee/files?commercial_id=${me?.commercial_id}&contract=1`,
            config,
          );
          _contract_id = _contract_id?.data[0]?.id;
          let { data: _contract_url } = await api.get(`trainee/files/${_contract_id}/download`, config);
          _contract_url = _contract_url?.download;
          setcontractUrl(_contract_url);
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar carregar o contrato da turma. Entre em contato com a nossa equipe.");
        } finally {
          setisLoadingEssential(false);
        }
      })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx); adding it would refire this fetch on unrelated context updates.
  }, [me]);

  const confirmAceite = async () => {
    try {
      setisLoadingSave(true);
      await api.put(
        `trainee/trainees/${me?.id}`,
        {
          aceite_virtual: 1,
          date_aceite: new Date(),
        },
        config,
      );
      window.location.reload();
      toast.success("Cadastro finalizado com sucesso.");
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar Aceitar o Contrato.");
    } finally {
      setisLoadingSave(false);
    }
  };
  return (
    <Main className={style.mainUser}>
      <Content>
        {!isLoadingEssential ? (
          <Row>
            <Col className="text-center">
              <h2 className="page-title mb-2">Aceite Virtual</h2>
              <p className="m-0">Seu cadastro está quase completo!</p>
              <p className="m-0">Para concluí-lo você precisa baixar o Contrato, lê-lo e aceitá-lo!</p>
              <div className="mt-3">
                <ButtonLink color="primary" to={contractUrl} target="_blank" download>
                  Download do Contrato
                </ButtonLink>
                <Button color="primary_ghost" onClick={confirmAceite} disabled={isLoadingSave}>
                  Li e Aceito o Contrato
                </Button>
              </div>
            </Col>
          </Row>
        ) : (
          <Loading />
        )}
      </Content>
    </Main>
  );
}
